import { useQuery } from "@tanstack/react-query";
import {
  fetchEngagements,
  FetchEngagementsPayload,
  FetchEngagementsResponse
} from "PFCore/services/engagements";
import { QueryOptions } from "PFTypes/request_options";

import { engagementsKeys } from "./query_keys";

export const useEngagements = (
  params: FetchEngagementsPayload,
  options: QueryOptions<FetchEngagementsResponse> = {}
) =>
  useQuery<FetchEngagementsResponse>({
    queryKey: engagementsKeys.list(params),
    queryFn: ({ signal }) => fetchEngagements(params, { signal }),
    ...options
  });
